import React from "react";
import { Route } from "react-router";
import ReplacementsPage from "pages/Replacements/ReplacementsPage";
import ReplacementReasonPage from "pages/Replacements/ReplacementReasonPage";
import ReplacementsReviewPage from "pages/Replacements/ReplacementsReviewPage";
import ReplacementConfirmationPage from "pages/Replacements/ReplacementConfirmationPage";
import ReplacementsShippingDetailsPage from "pages/Replacements/ReplacementsShippingDetailsPage";
import NewOrderFormProvider from "pages/OrderPages/NewOrderShippingDetailsPage/contexts/Form/NewOrderFormProvider";
import ReplacementResubmit from "pages/Errors/ReplacementResubmit";

export const ReplacementsRoutes = (
	<Route path="replacements">
		<Route
			path=":orderId"
			element={<ReplacementsPage />}
		/>
		<Route
			path="reason/:orderId"
			element={<ReplacementReasonPage />}
		/>
		<Route
			path="review/:orderId"
			element={<ReplacementsReviewPage />}
		/>
		<Route
			path="confirmation/:orderId"
			element={<ReplacementConfirmationPage />}
		/>
		<Route
			path="shipping-details/:orderId"
			element={
				<NewOrderFormProvider>
					<ReplacementsShippingDetailsPage />
				</NewOrderFormProvider>
			}
		/>
		<Route
			path="resubmit/:orderId"
			element={<ReplacementResubmit />}
		/>
	</Route>
);
